import produce from 'immer';
import {
	FETCH_PAGE_FAILED,
	FETCH_PAGE_FULFILLED,
	FETCH_PAGE_PENDING,
	SET_INITIAL_DATA_FULFILLED,
	TILE_DECORATION_MOUNTED,
} from '../constants/actions/pageActions';
import PageReducerState from '../interfaces/reducers/pageReducer';

const state: PageReducerState = {
	page: null,
	settings: null,
	appFrame: null,
	pages: {},
	loading: false,
	error404: false,
	error500: false,
	tileDecorationMounted: false,
};

const pageReducer = produce((draft, action) => {
	switch (action.type) {
		case FETCH_PAGE_PENDING: {
			draft.loading = true;
			draft.error404 = false;
			draft.error500 = false;
			break;
		}
		case SET_INITIAL_DATA_FULFILLED: {
			draft.loading = false;
			draft.page = action.payload.data.page;
			draft.error404 = false;
			draft.error500 = false;
			draft.pages[action.payload.data.page.Id] = action.payload.data.page;
			draft.settings = action.payload.data.settings;
			draft.appFrame = action.payload.data.appFrame;
			break;
		}
		case FETCH_PAGE_FULFILLED: {
			draft.loading = false;
			draft.page = action.payload.page;
			draft.error404 = false;
			draft.error500 = false;
			draft.pages[action.payload.page.Id] = action.payload.page;
			draft.tileDecorationMounted = false;
			break;
		}
		case FETCH_PAGE_FAILED: {
			draft.loading = false;
			draft.error404 = action.payload.status >= 400 && action.payload.status < 500;
			draft.error500 = action.payload.status >= 500 || action.payload.status === 0;
			break;
		}
		case TILE_DECORATION_MOUNTED: {
			draft.tileDecorationMounted = true;
			break;
		}
		default: {
			break;
		}
	}
}, state);

export default pageReducer;
